module.exports = __webpack_public_path__ + "img/window3.0821c99b.png";